export class MenuItemModel {
	constructor(public Id: number,
		public Name: string,
		public TranslatedName: string) {
	}
}